import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const setAudioPlaying = createAction('setAudioPlaying');
